import useSelectedPlanStore from '../stores/useSelectedPlanStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

/**
 * Composable function to open and close modal windows
 */
export const useSelectedPlan = () => passStoreThroughComposableFactory(useSelectedPlanStore());

export default useSelectedPlan;
